import type { GeoJsonGeometry } from '../geojsonBase';
import type { DefectFeaturesResponseBody } from '../contracts/defectFeatures';

export type DefectGeometryKind = 'polyline' | 'point' | 'multipoint' | 'polygon';

export type ArcGisGeoJsonGeometryType = DefectGeometryKind;

export function toArcGisGeometryType(kind: DefectGeometryKind): ArcGisGeoJsonGeometryType {
  return kind;
}

export function geometryKindFromGeoJsonType(
  geoJsonType: GeoJsonGeometry['type'],
): DefectGeometryKind {
  switch (geoJsonType) {
    case 'Point':
      return 'point';
    case 'MultiPoint':
      return 'multipoint';
    case 'Polygon':
      return 'polygon';
    case 'LineString':
    case 'MultiLineString':
      return 'polyline';
    case 'GeometryCollection':
      return 'polyline';
    default: {
      const unreachable: never = geoJsonType;
      return unreachable;
    }
  }
}

export function inferGeometryKindFromFeatures(
  collection: DefectFeaturesResponseBody,
): DefectGeometryKind {
  const first = collection.features[0];
  if (!first) {
    return 'polyline';
  }
  return geometryKindFromGeoJsonType(first.geometry.type);
}
